module.exports = function(bootstrap) {
	bootstrap.directive('dateRangeModal', ["modal", "$filter", function (modal, $filter) {
		return {
			scope: {
				dateRangeModal: '=',
				dateRangeOptions: '='
			},
			link: function(scope, element, attrs) {
				element.on('click', function() {
					var today = new Date();
					today.setHours(0);
					today.setMinutes(0);
					today.setSeconds(0);
					today.setMilliseconds(0);
					var min = '';
					var max = '';
					if (attrs.dateRangeMax) {
						max = ' max="' + $filter('date')(new Date(Number(today) + (attrs.dateRangeMax * 86400000)), 'yyyy-MM-dd') + '"';
					}
					if (attrs.dateRangeMin) {
						min = ' min="' + $filter('date')(new Date(Number(today) - (attrs.dateRangeMin * 86400000)), 'yyyy-MM-dd') + '"';
					}

					modal.open({
						heading: 'SELECT A DATE RANGE',
						classes: 'dateRangeWidget',
						controller: ["$scope", function($scope) {
		                	var parsedDate = JSON.parse(scope.dateRangeModal);
							$scope.startDate = new Date();
							$scope.startDate.setMonth(Number(parsedDate.startDate.substr(4,2)) - 1);
							$scope.startDate.setDate(parsedDate.startDate.substr(6,2));
							$scope.startDate.setFullYear(parsedDate.startDate.substr(0,4));
							$scope.startDate.setHours(0);
							$scope.startDate.setMinutes(0);
							$scope.startDate.setSeconds(0);
							$scope.startDate.setMilliseconds(0);
							$scope.endDate = new Date();
							$scope.endDate.setMonth(Number(parsedDate.endDate.substr(4,2)) - 1);
							$scope.endDate.setDate(parsedDate.endDate.substr(6,2));
							$scope.endDate.setFullYear(parsedDate.endDate.substr(0,4));
							$scope.endDate.setHours(0);
							$scope.endDate.setMinutes(0);
							$scope.endDate.setSeconds(0);
							$scope.endDate.setMilliseconds(0);
							$scope.save = function() {
								if (!$scope.startDate || !$scope.endDate) {
									return false;
								}
								var label = $filter('date')($scope.startDate, 'MM/dd/yyyy') + ' - ' +$filter('date')($scope.endDate, 'MM/dd/yyyy');
								var value = JSON.stringify({startDate: $filter('date')($scope.startDate, 'yyyyMMdd'), endDate: $filter('date')($scope.endDate, 'yyyyMMdd')});
				                for (var i = 0; i < scope.dateRangeOptions.length; i++) {
				                	var parsedValue = JSON.parse(scope.dateRangeOptions[i].value);
				                    if (scope.dateRangeOptions[i].value === value) {
										scope.dateRangeModal = value;
										$scope.closeModal();
										return;
				                    }
				                    else if (scope.dateRangeOptions[i].label === (parsedValue.startDate.substr(4,2) + '/' + parsedValue.startDate.substr(6,2) + '/' + parsedValue.startDate.substr(0,4) + ' - ' + parsedValue.endDate.substr(4,2) + '/' + parsedValue.endDate.substr(6,2) + '/' + parsedValue.endDate.substr(0,4))) {
				                    	scope.dateRangeOptions.splice(i,1);
				                    	i--;
				                    }
				                }
                 				scope.dateRangeOptions.push({ label: label, value: value });
								scope.dateRangeModal = value;
								$scope.closeModal();
							};
						}],
						template: 	'<div class="dateContainer">'+
										'<label>Start Date <input data-ng-model="startDate" type="date"'+max+min+'></label>'+
										'<div data-calendar="startDate" data-stay-less-than="endDate" data-date-max="'+attrs.dateRangeMax+'" data-date-min="'+attrs.dateRangeMin+'"></div>'+
									'</div>'+
									'<div class="dateContainer">'+
										'<label>End Date <input data-ng-model="endDate" type="date"'+max+min+'></label>'+
										'<div data-calendar="endDate" data-stay-more-than="startDate" data-date-max="'+attrs.dateRangeMax+'" data-date-min="'+attrs.dateRangeMin+'"></div>'+
									'</div>'+
									'<div class="margin-top text-right">'+
										'<button data-ng-click="closeModal()" class="secondary">CANCEL</button> <button data-ng-click="save()" class="primary">OK</button>'+
									'</div>'
					});
				});
			}
		};
	}]);
};